import { toCurrency, toCamelCase, FormItem, InfinityUtil } from "src/infinity-ui";
const { itemReducer } = new InfinityUtil();

export function arcRegisterFormSummary(store: any): any {
    var { participant, state, premium, total, adjustedPremium, agencyFee, taxes, fees, surcharge, surchargeType, programName, pfDownPayment, amountFinanced, itemSummaries } = store;
    const { firstName, middleName, lastName, businessName, email, phone, addressLine1, addressLine2, city, zipCode } = participant;

    const prefix = store.prefix.value;
    const suffix = store.suffix.value;

    const fullName = [prefix, firstName, middleName, lastName, suffix].filter(e => !!e).join(" ");
    const stateValue = state ? state.value : participant.state;
    const address = [addressLine1, addressLine2, city, stateValue].filter(e => !!e).join(", ") + ` ${zipCode}`;

    const summaryGroups = [
        arcSummaryGroup("Contact Summary", [
            ["Full Name", fullName],
            ["Company Name", businessName],
            ["Email", email],
            ["Phone", phone],
            ["Address", address]
        ]),
        arcSummaryGroup("Coverage Summary", itemSummaries.reduce(ratingItemSummaryReducer, [])),
    ];

    if (programName === "ata") {
        premium = adjustedPremium;
        agencyFee = null;
    }

    let taxesLabel = "Taxes";
    let feesLabel = "Fees";
    if (programName === "mofo") {
        taxesLabel = "Surplus Tax";
        feesLabel = "Stamping Fee";
    }

    if (programName === "ubs") {
        total = adjustedPremium;
    }

    if (!store.isReferral) summaryGroups.push(arcSummaryGroup("Annual Premium Total", [
        ["Premium", premium, toCurrency],
        ["Agency Fee", agencyFee, toCurrency],
        [taxesLabel, taxes, toCurrency],
        [feesLabel, fees, toCurrency],
        [surchargeType, surcharge, toCurrency],
        ["Total", total, toCurrency],
        ["Amount Financed", amountFinanced, toCurrency],
        ["Down Payment", pfDownPayment.label]
    ]));

    const formSummary = {
        type: "none",
        id: "formSummary",
        items: summaryGroups
    };

    // Make all items visible.
    const summaryItems = itemReducer([], formSummary);
    summaryItems.forEach(e => e.visible = true);
    
    return formSummary;
}

/* ----- Templates ----- */

function arcSummaryGroup(label: string, arr: Array<Array<any>>): FormItem {
    return {
        type: "none",
        itemId: label === "Annual Premium Total" ? "premiumInformation" : toCamelCase(label),
        items: [
            {
                type: "none",
                label: "<h2>" + label + "</h2>",
                className: "container",
                items: arr.filter(arr => !!arr[1]).map(arcSummaryItem)
            }
        ]
    };
}

function arcSummaryItem(data: Array<any>): FormItem {
    let [ groupLabel, itemLabel, itemValue, fn ] = data;    // Alias data arguments.
    if (!itemValue || itemValue instanceof Function) {      // If value is 2nd argument:
        if (itemValue instanceof Function) fn = itemValue;  // Set function argument.
        itemValue = itemLabel;                              // Set item value argument.
        itemLabel = null;                                   // Set item label argument.
    }
    return {
        type: "none",
        className: "bg-255 border-bot-1-200",
        label: getArcSummaryChildren(groupLabel, itemLabel, itemValue, fn)  
    };
}

/* ----- Middleware ----- */

function ratingItemSummaryReducer(arr: Array<Array<any>>, summary: any): Array<Array<any>> {
    if (!summary.visible) return arr;
    let { ratingItemDescription, value, parentRatingItemDescription, ratingGroupDescription } = summary;

    // set sublabel to ratingGroupDescription if no parent description exists
    let subLabel = parentRatingItemDescription || ratingGroupDescription;

    // Override the sublabels to ratingGroupDescription regardless of parent description
    if (subLabel && subLabel == "Coverage Information") {
        subLabel = ratingGroupDescription;
    }
   
    if (value) arr.push([ratingItemDescription, value]);
    else arr.push([subLabel, ratingItemDescription]);
    return arr;
}

function getArcSummaryChildren(groupLabel: string, itemLabel: string, itemValue:string, fn: any): string {
    return `<div class="pad-12-24 align">
            <div class="col-md-6">
                <div><strong>${groupLabel}</strong></div>
                ${itemLabel ? `<div class="pad-6-0">${itemLabel}</div>` : ""}
            </div>
            <div class="col-md-6">
                <div class="pad-0-24">${fn ? fn(itemValue) : itemValue}</div>
            </div>
        <div>`
}
